function addOverlay() {
    let idProducts = initializeArray();
    if (!!idProducts) {
        idProducts.forEach(id => {
            if (!!document.querySelectorAll(`.product-item__image-container--${id}`)) {
                let addedProduct = document.querySelectorAll(`.product-item__image-container--${id}`)
                addedProduct.forEach(el=>{
                    el.classList.add('product-added-overlay')
                    if (!!el.querySelector('.product-item--overlay')) {
                        el.querySelector('.product-item--overlay').classList.remove('hidden')
                    }
                })
            }
        });
    }
}
function removeOverlay(id) {
    if (!!document.querySelectorAll(`.product-item__image-container--${id}`)) {
        let addedProduct = document.querySelectorAll(`.product-item__image-container--${id}`)
        addedProduct.forEach(el=>{
            el.classList.remove('product-added-overlay')
            if (!!el.querySelector('.product-item--overlay')) {
                el.querySelector('.product-item--overlay').classList.add('hidden')
            }
        })
    }
}
function initializeArray() {
    const storedItems = sessionStorage.getItem('addedProduct');
    return storedItems ? JSON.parse(storedItems) : [];
}
function updateArray(newItem, itemRemove) {
    let itemArray = initializeArray();
    if (!!newItem) {
        itemArray.push(newItem);
    }
    
    if (!!itemRemove) {
        let itemToRemove = itemRemove
        itemArray = itemArray.filter(item => item !== itemToRemove); 
    }
    sessionStorage.setItem('addedProduct', JSON.stringify(itemArray));
}

if (window.theme.overlayEnable) {
    document.addEventListener("DOMContentLoaded", function () {
        addOverlay()
    })
    
    document.addEventListener('product:added', function(e) {
        let addedId = 0
        if (!!e.detail.variant) {
            if (!!e.detail.variant.id) {
                addedId = e.detail.variant.id
            }else {
                addedId = e.detail.variant
            }
             if (addedId !== 0) {
                updateArray(parseInt(addedId), null)
            }
            addOverlay()
        }
    })
    
    document.addEventListener('product:removed', function(e) {
      if (e.detail) {
        if (!!sessionStorage.getItem('addedProduct')) {
            updateArray(null,parseInt(e.detail))
            addOverlay()
            removeOverlay(e.detail)
        }
      }
    })
}
